module.exports = __webpack_public_path__ + "img/house-safe.4e8dd07c.svg";